import { render, staticRenderFns } from "./edit-note-dialog.vue?vue&type=template&id=54667b8d&scoped=true&"
import script from "./edit-note-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-note-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54667b8d",
  null
  
)

export default component.exports